import { useQuery, getWalletByPropFirm } from "wasp/client/operations";
import { Card } from "../../../client/components/ui/card";
import { CardSectionHeader } from "../../../client/components/ui/card-section-header";
import { WalletWithdrawalsTable } from "../../../prop-firm-manager/WalletWithdrawalsTable";
import { usePfmData } from "../../../prop-firm-manager/PfmDataContext";
import useTranslation from "../../../client/hooks/useTranslation";

export default function PropFirmWalletWithdrawalsWidget() {
  const t = useTranslation();
  const w = t.propFirmManager.wallet;
  const { tptWalletContext, isDark } = usePfmData();
  const tptTemplateId = (tptWalletContext as any)?.propFirmTemplateId ?? null;

  const { data: wallet, refetch } = useQuery(getWalletByPropFirm, tptTemplateId ? { propFirmTemplateId: tptTemplateId } : undefined, { enabled: !!tptTemplateId });

  if (!tptTemplateId) {
    return (
      <Card className="h-full flex flex-col">
        <CardSectionHeader label={w.withdrawalsTableTitle} isDark={isDark} compact />
        <div className="flex-1 flex flex-col items-center justify-center gap-1 px-4 py-6 text-center">
          <span className="text-sm font-medium text-foreground">{w.emptyTitle}</span>
          <span className="text-xs text-muted-foreground max-w-xs">{w.emptyDesc}</span>
        </div>
      </Card>
    );
  }

  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={w.withdrawalsTableTitle} isDark={isDark} compact />
      <div className="flex-1 overflow-auto p-4">
        <WalletWithdrawalsTable withdrawals={(wallet as any)?.withdrawals ?? []} onMutated={() => refetch()} />
      </div>
    </Card>
  );
}
